import Keycloak from 'keycloak-js';
import constants from './utils/constants';

let _keycloak = null;
let _keycloakRealm = 'zaya';
let _activeTenant = 'zaya';

export function setKeycloakContext({realm, tenant}) {
  if (_keycloak !== null) {
    throw new Error('Keycloak was already initialized');
  }
  _keycloakRealm = (realm || '').trim() || 'zaya';
  _activeTenant = (tenant || '').trim() || _keycloakRealm;
}

export function getActiveTenant() {
  return _activeTenant;
}

function getKeycloak() {
  if (!_keycloak) {
    // Strip /realms/{realm} if present, as Keycloak JS adds it automatically.
    let url = constants.IAM_URL;
    if (url.endsWith('/')) {
      url = url.slice(0, -1);
    }
    url = url.replace(/\/realms\/[^/]+$/, '');
    const initOptions = {
      url: url,
      realm: _keycloakRealm,
      // Configurable so the Keycloak client can be renamed (e.g. zaya-ims-sso-client) via
      // configuration.json (IAM_CLIENT_ID, rendered from helm keycloak.clientId). Falls back to 'core'.
      clientId: constants.IAM_CLIENT_ID || 'core',
      enableLogging: true
    };
    _keycloak = new Keycloak(initOptions);
  }
  return _keycloak;
}

const plugin = {
  install: Vue => {
    Object.defineProperty(Vue, '$keycloak', {
      get() {
        return getKeycloak();
      }
    });
    Object.defineProperties(Vue.prototype, {
      $keycloak: {
        get() {
          return getKeycloak();
        },
      },
    });
  },
};

export default plugin;
